export default __webpack_public_path__ + "static/media/metaverse.d818737f.webm";